module.exports = __webpack_public_path__ + "img/reju6.f10136c4.png";